import api from '@/apis/di/sysAccountParallelVoucherListRuleAPI';
import Crud from '@/stores/crudBaseCache';
var crud = new Crud('sysAccountParallelVoucherListRule', api);
const state = {
  ...crud.state,
  _config: {
    table: 'sys_account_parallel_voucher_list_rule',
    field: {
      key: 'rule_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
